import {
    loadingMap,
    getActionMap,
    getModule,
    getModuleName,
    getModules,
    getAcl,
    getUrl,
    getTools,
    getTool,
    getStateTools,
    getStateTool,
    getPanel,
    getPanelStatus,
    isPanelVisible,
    isPanelActive,
    getPanels,
    getConfig,
    getProjectionsMap,
    getConfigMap,
} from '@/app/shared/utils/stateGetterUtils';
import {Icon, Style} from 'ol/style';

const getters = {
    loadingMap: state => loadingMap(state),
    getActionMap: state => getActionMap(state),
    getCodeModule: state => state.data.code,
    getCodeApiModule: state => state.data.codeAPI,
    getModule: state => getModule(state),
    getModuleName: state => getModuleName(state),
    getModules: state => getModules(state),
    getTools: state => getTools(state),
    getTool: (state) => (id) => {
        return getTool(state, id);
    },
    getAcl: (state, getters) => (id) => {
        return getAcl(state, getters.getTools, id);
    },
    getUrl: (state, getters) => (id) => {
        return getUrl(state, getters.getTools, id);
    },
    getStateTools: (state, getters) => {
        return getStateTools(state, getters);
    },
    getStateTool: (state, getters) => (id) => {
        return getStateTool(state, getters, id);
    },
    getPanel: (state, getters) => (id) => {
        return getPanel(state, getters.getTools, id);
    },
    isPanelActive: (state, getters) => (id) => {
        return isPanelActive(getters, id);
    },
    isPanelVisible: (state, getters) => (id) => {
        return isPanelVisible(getters, id);
    },
    getPanels: (state, getters) => {
        return getPanels(state, getters.getTools);
    },
    getPanelStatus: (state, getters) => (id) => {
        return getPanelStatus(state, getters, id);
    },
    getConfig: (state) => (id) => {
        return getConfig(state, id);
    },
    getConfigMap: (state, getters, rootState) => {
        return getConfigMap(state, rootState);
    },
    getProjectionsMap: (state) => {
        return getProjectionsMap(state);
    },
    getFeatureStyleMap: (state) => {
        return function (feature, resolution) {
            let color = feature.get('color') || '#1DC2F3';
            let image = feature.get('image') || null;
            let selected = false; //feature.get('selected') || false;

            const styles = {};
            // const fill = new Fill({
            //     color: 'rgba(255,255,255, 1)',
            // });
            // const stroke = new Stroke({
            //     color: '#3399CC',
            //     width: 1.25,
            // });
            let mainSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="30px" height="30px" viewBox="248.78 206.87 254.45 338.27">\
                        <path fill="${color}" d="m376.04 206.87c-70.156 0-127.26 57.031-127.26 127.05 0 68.332 117.18 203.16 122.12 208.85 1.2852 1.4883 3.1797 2.3672 5.1406 2.3672 1.9609 0 3.7891-0.87891 5.0742-2.3672 5.0078-5.6836 122.12-140.52 122.12-208.85 0-70.023-57.035-127.05-127.19-127.05zm0 193.62c-36.668 0-66.504-29.902-66.504-66.57 0-36.602 29.836-66.438 66.504-66.438 36.602 0 66.438 29.836 66.438 66.438 0 36.668-29.836 66.57-66.438 66.57z"/>\
                    </svg>`;
            mainSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="32px" height="39px" viewBox="0 0 32 39">\
                        <path fill="${color}" d="M1 14.9133C1 7.25666 7.74536 1 16 1C24.2546 1 31 7.25666 31 14.9133C31 23.0868 22.1997 31.2172 17.4745 35.6324L16 37L14.5255 35.5893L14.4518 35.5209C9.72064 31.1327 1 23.0443 1 14.9133Z"></path>\
                        <path fill="#ffffff" d="M14.4518 35.5209L15.1318 34.7877L15.1318 34.7877L14.4518 35.5209ZM14.5255 35.5893L15.2169 34.8667L15.2113 34.8614L15.2056 34.8561L14.5255 35.5893ZM16 37L15.3087 37.7226L15.9894 38.3738L16.68 37.7332L16 37ZM17.4745 35.6324L18.1545 36.3655L18.1572 36.363L17.4745 35.6324ZM16 0C7.26523 0 0 6.63488 0 14.9133H2C2 7.87843 8.22549 2 16 2V0ZM0 14.9133C0 19.3161 2.34772 23.5918 5.1604 27.2321C7.98976 30.8939 11.4122 34.0656 13.7718 36.2541L15.1318 34.7877C12.7602 32.588 9.45677 29.5214 6.74302 26.0092C4.0126 22.4755 2 18.6415 2 14.9133H0ZM13.7717 36.254L13.8455 36.3225L15.2056 34.8561L15.1318 34.7877L13.7717 36.254ZM13.8342 36.3118L15.3087 37.7226L16.6913 36.2774L15.2169 34.8667L13.8342 36.3118ZM16.68 37.7332L18.1545 36.3655L16.7944 34.8992L15.32 36.2668L16.68 37.7332ZM18.1572 36.363C20.5111 34.1635 23.9522 30.9742 26.8 27.2942C29.6313 23.6357 32 19.3384 32 14.9133H30C30 18.6616 27.9686 22.5163 25.2183 26.0702C22.4847 29.6025 19.163 32.686 16.7917 34.9017L18.1572 36.363ZM32 14.9133C32 6.63488 24.7348 0 16 0V2C23.7745 2 30 7.87843 30 14.9133H32Z"></path>\
                    </svg>`;
            let mainAnchor = [0.5, 1];
            let childSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="14px" height="14px" viewBox="0 0 24 24">\
                                <path fill="#ffffff" d="M22 7.7V4.9H2v2.9s2.9.7 2.9 4.3c0 3.6-2.9 4.3-2.9 4.3v2.9h20v-2.9s-2.9-.7-2.9-4.3c0-3.7 2.9-4.4 2.9-4.4zm-10 10c-.9 0-1.4-.6-1.4-1.4 0-.9.6-1.4 1.4-1.4s1.4.6 1.4 1.4c0 .8-.5 1.4-1.4 1.4zm0-4.3c-.9 0-1.4-.6-1.4-1.4 0-.9.6-1.4 1.4-1.4s1.4.6 1.4 1.4c0 .9-.5 1.4-1.4 1.4zm0-4.3c-.9 0-1.4-.6-1.4-1.4 0-.9.6-1.4 1.4-1.4s1.4.6 1.4 1.4c0 .9-.5 1.4-1.4 1.4z"></path>\
                            </svg>`;
            let childAnchor = [0.5, 2.2];

            //highlight
            if(selected) {
                mainSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36 47" width="36" height="47">\
                            <path fill="#ffffff" d="M1 18.0051C1 8.64703 8.64474 1 18 1C27.3553 1 35 8.64703 35 18.0051C35 27.9949 25.0263 37.9321 19.6711 43.3285L18 45L16.3289 43.2758L16.2454 43.1922C10.8834 37.8289 1 27.943 1 18.0051Z"/>\
                            <path fill="${color}" d="M16.2454 43.1922L16.9526 42.4852L16.9525 42.4852L16.2454 43.1922ZM16.3289 43.2758L17.047 42.5798L17.0416 42.5743L17.0362 42.5688L16.3289 43.2758ZM18 45L17.2819 45.696L17.989 46.4255L18.7072 45.707L18 45ZM19.6711 43.3285L20.3783 44.0355L20.3809 44.0329L19.6711 43.3285ZM18 0C8.09217 0 0 8.09502 0 18.0051H2C2 9.19903 9.1973 2 18 2V0ZM0 18.0051C0 23.2876 2.61614 28.4541 5.79905 32.8965C8.99452 37.3566 12.8624 41.2228 15.5382 43.8992L16.9525 42.4852C14.2663 39.7983 10.5116 36.0399 7.42483 31.7317C4.32556 27.406 2 22.6606 2 18.0051H0ZM15.5381 43.8992L15.6217 43.9828L17.0362 42.5688L16.9526 42.4852L15.5381 43.8992ZM15.6109 43.9718L17.2819 45.696L18.7181 44.3041L17.047 42.5798L15.6109 43.9718ZM18.7072 45.707L20.3783 44.0355L18.9638 42.6214L17.2928 44.293L18.7072 45.707ZM20.3809 44.0329C23.0507 41.3425 26.9396 37.4548 30.1562 32.9723C33.3603 28.5072 36 23.3145 36 18.0051H34C34 22.6855 31.6528 27.4563 28.5313 31.8063C25.4222 36.139 21.6467 39.918 18.9612 42.6241L20.3809 44.0329ZM36 18.0051C36 8.09502 27.9078 0 18 0V2C26.8027 2 34 9.19903 34 18.0051H36Z"/>\
                        </svg>`;
                // child
                childSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" width="20" height="20">\
                        <circle fill="${color}" cx="12" cy="8.5" r="1"></circle>\
                        <circle fill="${color}" cx="12" cy="12" r="1"></circle>\
                        <circle fill="${color}" cx="12" cy="15.5" r="1"></circle>\
                        <path fill="${color}" d="M20 6.5V8c-1.5.7-2.5 2.3-2.5 4 0 1.8 1 3.3 2.5 4v1.5H4V16c1.5-.7 2.5-2.3 2.5-4 0-1.8-1-3.3-2.5-4V6.5h16m2-2H2v5c1.4 0 2.5 1.1 2.5 2.5S3.4 14.5 2 14.5v5h20v-5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5v-5z"></path>\
                    </svg>`;
                childAnchor = [0.5, 1.9];
            }

            let ptStyle = [
                // new Style({
                //     image: new Circle({
                //         fill: fill,
                //         stroke: stroke,
                //         radius: 5,
                //     }),
                // }),
                new Style({
                    image: new Icon({
                        opacity: 1,
                        src: 'data:image/svg+xml;utf8,' + encodeURIComponent(mainSvg),
                        scale: 1,
                        anchor: mainAnchor,
                    }),
                    zIndex: 0
                }),
                new Style({
                    image: new Icon({
                        opacity: 1,
                        src: image ? image : 'data:image/svg+xml;utf8,' + encodeURIComponent(childSvg),
                        scale: 1,
                        anchor: childAnchor,
                    }),
                    zIndex: 0
                }),
            ];

            if(image) {
                childAnchor = [0.5, 1];
                ptStyle = [
                    new Style({
                        image: new Icon({
                            opacity: 1,
                            src: image,
                            scale: 1,
                            anchor: childAnchor,
                        }),
                        zIndex: 0
                    }),
                ];
            }

            styles['point'] = ptStyle;
            return styles[feature.getGeometry().getType().toLowerCase()];
        };

        // const styles = {};
        // const white = [255, 255, 255, 1];
        // const blue = [0, 153, 255, 1];
        // const width = 3;
        // styles[GeometryType.POLYGON] = [
        //     new Style({
        //         fill: new Fill({
        //             color: [255, 255, 255, 0.5],
        //         }),
        //     }),
        // ];
        // styles[GeometryType.MULTI_POLYGON] = styles[GeometryType.POLYGON];

        // styles[GeometryType.LINE_STRING] = [
        //     new Style({
        //         stroke: new Stroke({
        //             color: white,
        //             width: width + 2,
        //         }),
        //     }),
        //     new Style({
        //         stroke: new Stroke({
        //             color: blue,
        //             width: width,
        //         }),
        //     }),
        // ];
        // styles[GeometryType.MULTI_LINE_STRING] = styles[GeometryType.LINE_STRING];

        // styles[GeometryType.CIRCLE] = styles[GeometryType.POLYGON].concat(styles[GeometryType.LINE_STRING]);

        // styles['point'] = [
        //     new Style({
        //         image: new CircleStyle({
        //             radius: width * 2,
        //             fill: new Fill({
        //                 color: blue,
        //             }),
        //             stroke: new Stroke({
        //                 color: white,
        //                 width: width / 2,
        //             }),
        //         }),
        //         zIndex: Infinity,
        //     }),
        // ];
        // styles[GeometryType.MULTI_POINT] = styles['point'];

        // styles[GeometryType.GEOMETRY_COLLECTION] = styles[GeometryType.POLYGON]
        //     .concat(styles[GeometryType.LINE_STRING], styles['point']);

        // return function (feature, resolution) {
        //     return styles[feature.getGeometry().getType()];
        // };
    },
    getFeatureSelectedStyleMap: (state) => {
        return function (feature, resolution) {
            feature = feature.get('features') && feature.get('features').length == 1 ? feature.get('features')[0] : feature;
            let color = feature.get('color') || '#1DC2F3';

            const styles = {};
            let mainSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 36 47" width="36" height="47">\
                            <path fill="#ffffff" d="M1 18.0051C1 8.64703 8.64474 1 18 1C27.3553 1 35 8.64703 35 18.0051C35 27.9949 25.0263 37.9321 19.6711 43.3285L18 45L16.3289 43.2758L16.2454 43.1922C10.8834 37.8289 1 27.943 1 18.0051Z"/>\
                            <path fill="${color}" d="M16.2454 43.1922L16.9526 42.4852L16.9525 42.4852L16.2454 43.1922ZM16.3289 43.2758L17.047 42.5798L17.0416 42.5743L17.0362 42.5688L16.3289 43.2758ZM18 45L17.2819 45.696L17.989 46.4255L18.7072 45.707L18 45ZM19.6711 43.3285L20.3783 44.0355L20.3809 44.0329L19.6711 43.3285ZM18 0C8.09217 0 0 8.09502 0 18.0051H2C2 9.19903 9.1973 2 18 2V0ZM0 18.0051C0 23.2876 2.61614 28.4541 5.79905 32.8965C8.99452 37.3566 12.8624 41.2228 15.5382 43.8992L16.9525 42.4852C14.2663 39.7983 10.5116 36.0399 7.42483 31.7317C4.32556 27.406 2 22.6606 2 18.0051H0ZM15.5381 43.8992L15.6217 43.9828L17.0362 42.5688L16.9526 42.4852L15.5381 43.8992ZM15.6109 43.9718L17.2819 45.696L18.7181 44.3041L17.047 42.5798L15.6109 43.9718ZM18.7072 45.707L20.3783 44.0355L18.9638 42.6214L17.2928 44.293L18.7072 45.707ZM20.3809 44.0329C23.0507 41.3425 26.9396 37.4548 30.1562 32.9723C33.3603 28.5072 36 23.3145 36 18.0051H34C34 22.6855 31.6528 27.4563 28.5313 31.8063C25.4222 36.139 21.6467 39.918 18.9612 42.6241L20.3809 44.0329ZM36 18.0051C36 8.09502 27.9078 0 18 0V2C26.8027 2 34 9.19903 34 18.0051H36Z"/>\
                        </svg>`;
            let mainAnchor = [0.5, 1];

            // child
            let childSvg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24" width="20" height="20">\
                        <circle fill="${color}" cx="12" cy="8.5" r="1"></circle>\
                        <circle fill="${color}" cx="12" cy="12" r="1"></circle>\
                        <circle fill="${color}" cx="12" cy="15.5" r="1"></circle>\
                        <path fill="${color}" d="M20 6.5V8c-1.5.7-2.5 2.3-2.5 4 0 1.8 1 3.3 2.5 4v1.5H4V16c1.5-.7 2.5-2.3 2.5-4 0-1.8-1-3.3-2.5-4V6.5h16m2-2H2v5c1.4 0 2.5 1.1 2.5 2.5S3.4 14.5 2 14.5v5h20v-5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5v-5z"></path>\
                    </svg>`;
            let childAnchor = [0.5, 1.9];

            styles['point'] = [
                new Style({
                    image: new Icon({
                        opacity: 1,
                        src: 'data:image/svg+xml;utf8,' + encodeURIComponent(mainSvg),
                        scale: 1,
                        anchor: mainAnchor,
                    }),
                    zIndex: 1
                }),
                new Style({
                    image: new Icon({
                        opacity: 1,
                        src: 'data:image/svg+xml;utf8,' + encodeURIComponent(childSvg),
                        scale: 1,
                        anchor: childAnchor,
                    }),
                    zIndex: 1
                }),
            ];
            return styles[feature.getGeometry().getType().toLowerCase()];
        };
    },
};

export default getters;